/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
    SourceToJSONTyped,
} from './Source';

/**
 * 
 * @export
 * @interface CreateSource201Response
 */
export interface CreateSource201Response {
    /**
     * 
     */
    data?: Source;
}

/**
 * Check if a given object implements the CreateSource201Response interface.
 */
export function instanceOfCreateSource201Response(value: object): value is CreateSource201Response {
    return true;
}

export function CreateSource201ResponseFromJSON(json: any): CreateSource201Response {
    return CreateSource201ResponseFromJSONTyped(json, false);
}

export function CreateSource201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSource201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SourceFromJSON(json['data']),
    };
}

export function CreateSource201ResponseToJSON(json: any): CreateSource201Response {
    return CreateSource201ResponseToJSONTyped(json, false);
}

export function CreateSource201ResponseToJSONTyped(value?: CreateSource201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SourceToJSON(value['data']),
    };
}

